export const ANALYTICS_CONFIG_LOCATION = 'u21-ui-analytics-config';
